import { useMemo } from 'react';
import { CORE_WEB_VITALS_CONFIG } from '../constants/coreWebVitals';
import { getCoreWebVitalStatus, formatCoreWebVitalValue } from '../utils/formatters';

export const useCoreWebVitals = (coreWebVitals) => {
    const coreWebVitalsSummary = useMemo(() => {
        if (!coreWebVitals) {
            return [];
        }

        return CORE_WEB_VITALS_CONFIG.map(config => {
            const rawValue = coreWebVitals[config.key];
            const hasValue = rawValue !== null && rawValue !== undefined;
            const status = getCoreWebVitalStatus(config, rawValue);

            return {
                ...config,
                value: hasValue ? Number(rawValue) : null,
                displayValue: hasValue ? formatCoreWebVitalValue(config, rawValue) : '—',
                statusLabel: status.label,
                statusColor: status.color,
                statusTextColor: status.textColor
            };
        });
    }, [coreWebVitals]);

    const previewCoreWebVitals = useMemo(() => {
        return coreWebVitalsSummary.filter(item => item.showInPreview && item.value !== null);
    }, [coreWebVitalsSummary]);

    return {
        coreWebVitalsSummary,
        previewCoreWebVitals
    };
};






